import React, { useEffect, useState } from "react";
import { Button, CustomStepper, Loader } from "InnoUI/components";
import SC from "./style";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import InnoIcons from "InnoUI/innoicons";
import theme from "theme";
import { useSearchParams } from "react-router-dom";
import MessageContent from "./MessageContent";
import AlarmContent from "./AlarmContent";
import NotificationContent from "./NotificationContent";
import RequestContent from "./RequestContent";
import axios from "axios";
import {
  getUpdateRequest,
  readFromLocalStorage,
  showAlert,
} from "utils/helper";
import CustomBreadcrumb from "components/CustomBreadcrumb";
import { apiGet, apiPost } from "api/callApi";
import messageTemplate from "utils/messageTemplate";
import { requestTypeForUpdate } from "utils/optionData/utils";
import JournalSkeleton from "components/JournalSkeleton";
import { toJournalAttachmentPayload } from "../utils/attachmentUpload";

const UpdateJournal = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectId = searchParams.get("projectId");
  const folderId = searchParams.get("folderId");
  const journalId = searchParams.get("journalId");
  const isEditing = searchParams.get("isEditing");
  const isReply = searchParams.get("isReply");
  const roleId = searchParams.get("roleId");
  const [activeStep, setActiveStep] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const authData = useSelector((state) => state?.authdata?.data || []);
  const [data, setData] = useState();
  const [intitalRequestType, setInitialRequestType] = useState(1);
  const [journalData, setJournalData] = useState(null);
  const [getDataLoading, setGetDataLoading] = useState(false);

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );

  const steps = [
    { heading: "Message", description: "Insert Journal Subject & Content" },
    { heading: "Request", description: "Request Type & Role Players" },
    { heading: "Alarm", description: "Primary Alarm & Secondary Pre-alarm" },
    { heading: "Notification", description: "Send Journal Notification" },
  ];

  const getJournalData = async () => {
    try {
      setGetDataLoading(true);
      const response = await apiGet(`/v1/journal/${journalId}`);

      const journalData = response.data[0];

      setJournalData(journalData);

      // Filter alarms for primary (alarmType = 0) and secondary (alarmType = 1)
      const primaryAlarm =
        journalData?.alarm?.find((a) => a.alarmType === 0) || {};
      const secondaryAlarm =
        journalData?.alarm?.find((a) => a.alarmType === 1) || {};

      const request = requestTypeForUpdate.find(
        (item) => item.id === journalData?.requestType,
      );

      const sendToName =
        journalData?.sendToWithName?.map((user) => user?.name).join(", ") ||
        "none";
      const sendCcWithName =
        journalData?.sendCcWithName?.map((user) => user?.name).join(", ") ||
        "none";
      const sendBccWithName =
        journalData?.sendBccWithName?.map((user) => user?.name).join(", ") ||
        "none";
      // Map the response data to match your current state structure
      setInitialRequestType(journalData?.requestType || 1);

      let files = [];
      if (!isReply && journalData?.files?.length > 0) {
        files = journalData.files.map((file) => ({
          ...file,
          name: file.fileName,
          type: file.fileType,
          size: Number(file.fileSize || 0) * 1024,
          isExistingAttachment: true,
        }));
      }

      console.log(
        "journalData",
        journalData,
        "files",
        files,
        "request",
        request,
      );

      const mappedData = {
        parentId: journalData?.parentId || null,
        subject: journalData?.subject || "",
        message: messageTemplate(
          authData,
          journalData?.createdOn,
          journalData?.subject,
          request?.label,
          sendToName,
          sendCcWithName,
          sendBccWithName,
          journalData?.message,
          currentProject?.timeZone,
        ),
        roles:
          journalData?.roles
            ?.filter((role) => role.replied == 0)
            .map((r) => r.roleId) || [],
        // users: journalData?.users?.map((role) => role.userId) || [],
        users: journalData?.users?.map((user) => user.userId) || [],
        saveOption: journalData?.saveOption ?? 0,
        requestType:
          journalData?.requestHold == 1
            ? journalData?.requestType
            : getUpdateRequest(journalData?.requestType || 1),
        linktoproject: journalData?.linktoproject || null,
        primaryalarm: {
          active: 0,
          alarmType: 0,
          alarmTo: authData.email,
        },
        // primaryalarm: {
        //   active: primaryAlarm?.active || 1,
        //   alarmType: primaryAlarm?.alarmType || 0,
        //   alarmTo: primaryAlarm?.alarmTo || "",
        //   alarmDate: primaryAlarm?.alarmDate || "",
        //   alarmTime: primaryAlarm?.alarmTime || "",
        // },
        secondaryalarm: {
          active: 0,
          alarmType: 1,
          //alarmDate: secondaryAlarm?.alarmDate || "",
        },
        // secondaryalarm: {
        //   active: secondaryAlarm?.active || 0,
        //   alarmType: secondaryAlarm?.alarmType || 1,
        //   alarmTo: secondaryAlarm?.alarmTo || "",
        //   alarmDate: secondaryAlarm?.alarmDate || "",
        //   alarmTime: secondaryAlarm?.alarmTime || "",
        //   message: secondaryAlarm?.message || "",
        // },
        sendTo: journalData?.sendTo,
        sendCc: journalData?.sendCc,
        sendBcc: journalData?.sendBcc,
        rolesData: journalData?.roles,
        requestHold: journalData?.requestHold,
        files,
        existingAttachmentIds: files.map((file) => file.id).filter(Boolean),
      };

      const roleName = journalData?.roles?.find(
        (role) => role.roleId == roleId,
      )?.roleName;

      if (isReply) {
        setData({
          message: `<p><br></p><p>Regards,</p><p><span style="color: rgb(255, 153, 0);">${authData?.fullName}</span></p>`,
          subject: `${journalData?.subject} - ${request.label} - Reply from ${roleName}`,
          saveOption: 1,
          reply: isReply,
          journalId: journalId,
          roleId: roleId,
          requestType: 1,
          primaryalarm: {
            active: 0,
            alarmType: 0,
            alarmTo: authData.email,
          },
          secondaryalarm: {
            active: 0,
            alarmType: 1,
          },
        });
      } else if (isEditing) {
        setData({
          message: journalData?.message,
          subject: journalData?.subject || "",
          files,
          removedAttachmentIds: [],
        });
      } else {
        setData(mappedData);
      }
      setGetDataLoading(false);
    } catch (error) {
      setGetDataLoading(false);
      console.log("Error fetching journal data:", error);
    }
  };

  useEffect(() => {
    getJournalData();
  }, [journalId]);

  // handlenext button
  const handleNext = () => {
    if (!data?.subject) {
      setErrorMessage("Subject is required");
      return;
    }

    let active = data?.primaryalarm?.active,
      alarmTo = data?.primaryalarm?.alarmTo,
      alarmTime = data?.primaryalarm?.alarmTime,
      alarmDate = data?.primaryalarm?.alarmDate;

    if (
      activeStep == 2 &&
      ((active == 1 && !alarmDate) ||
        (active == 1 && !alarmTo) ||
        (active == 1 && !alarmTime))
    ) {
      showAlert({
        title: "Warning",
        text: "Primary Alarm details are required",
        icon: "warning",
      });
      return;
    }

    if (activeStep == 1 && data.requestType > 2) {
      setData((prevData) => ({
        ...prevData,
        primaryalarm: {
          ...prevData.primaryalarm,
          active: 1,
        },
      }));
    }

    if (
      activeStep == 1 &&
      data.requestType != 1 &&
      data.requestType != 2 &&
      (!data.users || data.users.length == 0)
    ) {
      showAlert({
        title: "Warning",
        text: "Users are required!",
        icon: "warning",
      });
      return;
    }

    let sactive = data?.secondaryalarm?.active,
      salarmTo = data?.secondaryalarm?.alarmTo,
      salarmTime = data?.secondaryalarm?.alarmTime,
      salarmDate = data?.secondaryalarm?.alarmDate,
      smessage = data?.secondaryalarm?.message;

    if (
      activeStep == 2 &&
      ((sactive == 1 && !salarmDate) ||
        (sactive == 1 && !salarmTo) ||
        (sactive == 1 && !salarmTime) ||
        (sactive == 1 && !smessage))
    ) {
      showAlert({
        title: "Warning",
        text: "Secondary Alarm details are required",
        icon: "warning",
      });
      return;
    }

    setErrorMessage("");
    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    }
  };

  // handleBack
  const handleBack = () => {
    // Move to the previous step if applicable

    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const {
    REACT_APP_BASE_URL: baseURL,
    REACT_APP_REQUEST_TIMEOUT: timeout,
    REACT_APP_API_KEY,
  } = process.env;

  let accessToken = REACT_APP_API_KEY;
  let userAuth = readFromLocalStorage("userAccessToken");
  let BASE_URL = baseURL || `${window.location.origin}/api`;
  userAuth = userAuth === null ? "" : userAuth;

  // handleSubmit
  const handleSubmit = async (e, isFinish = false) => {
    e.preventDefault();

    if (data.attachmentUploading) {
      showAlert({
        title: "Info",
        text: "Please wait until attachments finish uploading.",
        icon: "info",
      });
      return;
    }

    const payload = { ...data };
    // Check if sendTo is missing or empty
    if (!payload?.sendTo && isFinish) {
      // if sendTo is undefined, null, or empty string
      payload.saveOption = 1;
    } else {
      payload.saveOption = payload.saveOption ?? 0;
    }
    // Create a FormData object
    const formData = new FormData();

    // Append scalar fields
    formData.append("reply", payload.reply || "");
    formData.append("journalId", payload.journalId || "");
    formData.append("roleId", payload.roleId || "");
    formData.append("parentId", payload.parentId || "");
    formData.append("requestHold", payload.requestHold);
    formData.append("message", payload.message || "");
    formData.append("subject", payload.subject || "");
    formData.append("requestType", payload.requestType || "");
    formData.append("saveOption", payload.saveOption);
    const repliedOnly = payload?.rolesData?.filter((item) => item.replied == 1);
    formData.append(
      "repliedRolesData",
      repliedOnly ? JSON.stringify(repliedOnly) : null,
    );

    const uploadedAttachments = (payload.files || []).filter(
      (file) => file?.isUploadedAttachment,
    );
    const existingAttachmentIds =
      payload.existingAttachmentIds ||
      (payload.files || [])
        .filter((file) => file?.isExistingAttachment && file?.id)
        .map((file) => file.id);

    if (uploadedAttachments.length > 0) {
      formData.append(
        "attachments",
        JSON.stringify(toJournalAttachmentPayload(uploadedAttachments)),
      );
    }
    if (existingAttachmentIds.length > 0) {
      existingAttachmentIds.forEach((id) => {
        formData.append("existingAttachmentIds[]", id);
      });
    }

    // Append primaryalarm as JSON string
    formData.append("primaryalarm", JSON.stringify(payload.primaryalarm || {}));

    // Append secondaryalarm as JSON string
    formData.append(
      "secondaryalarm",
      JSON.stringify(payload.secondaryalarm || {}),
    );

    // Append roles array
    if (payload.roles && payload.roles.length > 0) {
      payload.roles.forEach((role) => {
        formData.append("roles[]", role);
      });
    }

    // Append users array
    if (payload.users && payload.users.length > 0) {
      payload.users.forEach((user) => {
        formData.append("users[]", user);
      });
    }
    // Append users array
    if (payload.linktoproject && payload.linktoproject.length > 0) {
      payload.linktoproject.forEach((user) => {
        formData.append("linktoproject[]", user);
      });
    }

    // Append email fields
    formData.append("sendTo", payload.sendTo || "");
    formData.append("sendCc", payload.sendCc || "");
    formData.append("sendBcc", payload.sendBcc || "");

    try {
      setLoading(true);
      let endpoint = `/v1/journal/updatejournal/${journalData?.projectId}/${journalData?.projectType}`;
      const url = BASE_URL + endpoint;
      const requestTimeout = timeout ? parseInt(timeout, 10) * 1000 : 180000;

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          api_key: accessToken,
          Authorization: `Bearer ${userAuth}`,
        },
        timeout: requestTimeout,
      });
      setLoading(false);
      showAlert({
        title: "Success",
        text: response?.data?.message || "File updated successfully.",
        icon: "success",
      });
      if (payload.requestType == 1 || payload.requestType == 2) {
        navigate(-1);
      } else {
        navigate(-1);
      }
    } catch (error) {
      console.error("Error making API call:", error);
      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An unexpected error occurred.",
        icon: "error",
      });
      setLoading(false);
    }
  };

  const handleEdit = async () => {
    if (!data?.subject) {
      setErrorMessage("Subject is required");
      return;
    }
    if (data.attachmentUploading) {
      showAlert({
        title: "Info",
        text: "Please wait until attachments finish uploading.",
        icon: "info",
      });
      return;
    }
    try {
      setLoading(true);
      const response = await apiPost(`/v1/journal/editjournal/${journalId}`, {
        subject: data.subject,
        message: data.message,
        attachments: toJournalAttachmentPayload(
          (data.files || []).filter((file) => file?.isUploadedAttachment),
        ),
        removedAttachmentIds: data.removedAttachmentIds || [],
      });

      showAlert({
        title: "Success",
        text: response?.message || "File updated successfully.",
        icon: "success",
      });
      setLoading(false);
      navigate(-1);
    } catch (error) {
      console.log("Error", error);

      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An unexpected error occurred.",
        icon: "error",
      });
      setLoading(false);
    }
  };

  const cleanupDraftUploads = async () => {
    const draftUploads = (data?.files || []).filter(
      (file) => file?.isUploadedAttachment && file?.fileUrl,
    );

    await Promise.all(
      draftUploads.map((file) =>
        apiPost("/v1/aws/file/deletefile", { fileKey: file.fileUrl }).catch(
          (error) => console.warn("Unable to cleanup draft attachment", error),
        ),
      ),
    );
  };

  const handleBackClick = async () => {
    if (data?.attachmentUploading) {
      showAlert({
        title: "Info",
        text: "Please wait until attachments finish uploading.",
        icon: "info",
      });
      return;
    }
    await cleanupDraftUploads();
    navigate(-1);
  };

  if (getDataLoading) {
    return <JournalSkeleton />;
  }
  return (
    <>
      <CustomBreadcrumb />
      <SC.NameContainer>
        <SC.ArrowC>
          <SC.ArrowBackIcon onClick={() => handleBackClick()} />
          <SC.Name>
            {isEditing
              ? "Edit Journal"
              : isReply
                ? "New Journal"
                : "Update Journal"}
          </SC.Name>
        </SC.ArrowC>
      </SC.NameContainer>

      {!isEditing && (
        <SC.CustomStepperContainer>
          <CustomStepper
            steps={steps}
            handleNext={handleNext}
            handleBack={handleBack}
            activeStep={activeStep}
          />
        </SC.CustomStepperContainer>
      )}

      <SC.CardContainerStyle>
        <SC.ButtonContaiiner
          style={{ justifyContent: "flex-start", margin: "0px 0px 10px 0px" }}
        >
          {activeStep == 0 && (
            <Button
              caption="Cancel"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              onClick={handleBackClick}
            />
          )}

          {!isEditing && (
            <>
              {activeStep > 0 && (
                <Button
                  caption="Back"
                  fontSize="12px"
                  style={{
                    marginBottom: 8,
                    background: theme.colors.cancelButton,
                    color: theme.colors.white,
                    minWidth: "100px",
                    borderRadius: "3px",
                    height: "30px",
                    fontSize: "12px",
                  }}
                  disabled={activeStep === 0 || loading}
                  onClick={handleBack}
                />
              )}

              {(isReply ? activeStep < 3 : activeStep === 0) && (
                <Button
                  caption={loading ? "Submitting..." : "Finish"}
                  isLoading={loading}
                  fontSize="12px"
                  color="white"
                  style={{
                    marginBottom: 8,
                    background: theme.gradient.themeGradient,
                    color: theme.colors.white,
                    minWidth: "100px",
                    borderRadius: "3px",
                    height: "30px",
                    fontSize: "12px",
                  }}
                  onClick={handleSubmit}
                  disabled={loading || data?.attachmentUploading}
                />
              )}

              {activeStep < steps.length - 1 && (
                <Button
                  caption="Next"
                  color="white"
                  fontSize="12px"
                  style={{
                    marginBottom: 8,
                    background: theme.gradient.themeGradient,
                    color: theme.colors.white,
                    minWidth: "100px",
                    height: "30px",
                    borderRadius: "3px",
                  }}
                  disabled={activeStep === steps.length - 1}
                  onClick={handleNext}
                />
              )}

              {activeStep === steps.length - 1 && (
                <Button
                  caption={loading ? "Submitting..." : "Submit"}
                  type="submit"
                  color="white"
                  fontSize="12px"
                  style={{
                    marginBottom: 8,
                    background: theme.gradient.themeGradient,
                    color: theme.colors.white,
                    minWidth: "100px",
                    height: "30px",
                    borderRadius: "3px",
                  }}
                  onClick={handleSubmit}
                  disabled={loading || data?.attachmentUploading}
                />
              )}
            </>
          )}

          {isEditing && (
            <Button
              caption={loading ? "Submitting..." : "Submit"}
              type="submit"
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
              onClick={handleEdit}
              disabled={loading || data?.attachmentUploading}
            />
          )}
        </SC.ButtonContaiiner>

        {activeStep === 0 && (
          <MessageContent
            setData={setData}
            data={data}
            errorMessage={errorMessage}
            isEditing={isEditing}
          />
        )}
        {activeStep === 1 && (
          <RequestContent
            setData={setData}
            data={data}
            intitalRequestType={intitalRequestType}
            journalData={journalData}
          />
        )}
        {activeStep === 2 && <AlarmContent setData={setData} data={data} />}
        {activeStep === 3 && (
          <NotificationContent
            setData={setData}
            data={data}
            loading={loading}
          />
        )}

        <SC.ButtonContaiiner>
          {activeStep == 0 && (
            <Button
              caption="Cancel"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              onClick={handleBackClick}
            />
          )}

          {!isEditing && (
            <>
              {activeStep > 0 && (
                <Button
                  caption="Back"
                  fontSize="12px"
                  style={{
                    marginBottom: 8,
                    background: theme.colors.cancelButton,
                    color: theme.colors.white,
                    minWidth: "100px",
                    borderRadius: "3px",
                    height: "30px",
                    fontSize: "12px",
                  }}
                  disabled={activeStep === 0 || loading}
                  onClick={handleBack}
                />
              )}

              {(isReply ? activeStep < 3 : activeStep === 0) && (
                <Button
                  caption={loading ? "Submitting..." : "Finish"}
                  isLoading={loading}
                  fontSize="12px"
                  color="white"
                  style={{
                    marginBottom: 8,
                    background: theme.gradient.themeGradient,
                    color: theme.colors.white,
                    minWidth: "100px",
                    borderRadius: "3px",
                    height: "30px",
                    fontSize: "12px",
                  }}
                  onClick={(e) => handleSubmit(e, true)}
                  disabled={loading || data?.attachmentUploading}
                />
              )}

              {activeStep < steps.length - 1 && (
                <Button
                  caption="Next"
                  color="white"
                  fontSize="12px"
                  style={{
                    marginBottom: 8,
                    background: theme.gradient.themeGradient,
                    color: theme.colors.white,
                    minWidth: "100px",
                    height: "30px",
                    borderRadius: "3px",
                  }}
                  disabled={activeStep === steps.length - 1}
                  onClick={handleNext}
                />
              )}

              {activeStep === steps.length - 1 && (
                <Button
                  caption={loading ? "Submitting..." : "Submit"}
                  type="submit"
                  color="white"
                  fontSize="12px"
                  style={{
                    marginBottom: 8,
                    background: theme.gradient.themeGradient,
                    color: theme.colors.white,
                    minWidth: "100px",
                    height: "30px",
                    borderRadius: "3px",
                  }}
                  onClick={(e) => handleSubmit(e, false)}
                  disabled={loading || data?.attachmentUploading}
                />
              )}
            </>
          )}

          {isEditing && (
            <Button
              caption={loading ? "Submitting..." : "Submit"}
              type="submit"
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
              onClick={handleEdit}
              disabled={loading || data?.attachmentUploading}
            />
          )}
        </SC.ButtonContaiiner>
      </SC.CardContainerStyle>
    </>
  );
};

export default UpdateJournal;
